import { DOMAIN } from '../Constants/base';
import { postReq } from '../utils/api';

export const verifyGoogleIdToken = async (authorization) => {
  try {
    const url = `${DOMAIN}/v1/user/v2/login/sso/google`;
    const payload = {
      authorization,
    };
    const response = await postReq({ url, payload });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyMicrosoftIdToken = async (authorization) => {
  try {
    const url = `${DOMAIN}/v1/user/v2/login/sso/microsoft`;
    const payload = {
      authorization,
    };
    const response = await postReq({ url, payload });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const generateOtp = async (email) => {
  try {
    const url = `${DOMAIN}/v1/user/v2/login/otp`;
    const requestBody = {
      email,
    };
    const response = await postReq({ url, requestBody });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyOtp = async (email, otp) => {
  try {
    const url = `${DOMAIN}/v1/user/v2/login/otp/verify`;
    const requestBody = {
      email,
      otp,
    };
    const response = await postReq({ url, requestBody });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyGoogleIdTokenV2 = async (payload) => {
  try {
    const url = `${DOMAIN}/v1/user/v2/login/sso/google`;

    const response = await postReq({ url, payload });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyAppleIdTokenV2 = async (payload) => {
  try {
    const url = `${DOMAIN}/v1/user/v2/login/sso/apple`;

    const response = await postReq({ url, payload });
    return response;
  } catch (error) {
    console.log(error);
  }
};
